<template>
  <div class="subtitle">
    <div>{{ $t("walletVerification.subtitle_3") }}</div>

    <div v-if="!statusConnection">
      {{ $t("walletVerification.subtitle_4") }}
    </div>
    <div v-else>
      {{ $t("walletVerification.subtitle_5") }}
    </div>

    <div
      v-if="satusOpenWallet && statusConnection"
      class="mt-4"
    >
      {{ $t("walletVerification.subtitleNote2") }}
    </div>
    <div v-if="satusOpenWallet && statusConnection">
      {{ $t("walletVerification.subtitleNote3") }}
    </div>

    <AuButton
      class="mt-4"
      type="primary"
      center
      width="200px"
      @click="$emit('connectWallet')"
    >
      <div class="btn_metamask">
        {{ $t("walletVerification.btn_2") }}
      </div>
    </AuButton>
  </div>
</template>

<script>
import AuButton from "@/components/extended/AuButton.vue";

export default {
  name: "ConnectWallet",
  components: { AuButton },
  props: {
    statusConnection: Boolean,
    satusOpenWallet: Boolean
  }
};
</script>
